import { LitElement, html, css } from "lit";
export class Row extends LitElement {
    constructor() {
        super();
        this.type = "fill";
    }
    render() {
        return html `<slot></slot>`;
    }
}
Row.properties = {
    type: { type: String, reflect: true },
};
Row.styles = css `
    :host {
      display: flex;
      align-items: end;
      width: calc(240px * var(--scaling-factor));
    }

    :host([type="fill"]) {
      justify-content: space-between;
      height: calc(var(--1) * var(--scaling-factor));
    }

    :host([type="centered"]) {
      justify-content: center;
      height: calc(var(--1) * var(--scaling-factor));
      gap: calc(var(--025) * var(--scaling-factor));
    }
  `;
customElements.define("row-v1", Row);
